import { render } from "./App.vue?vue&type=template&id=727d16bc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=727d16bc&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__